<template>
	<div>
		<header class="header">
			<img src="./images/overseas_bg.png" alt="">
			<navHeader ref=navHeader></navHeader>
			<div class="dbox">
				<p>{{langtrans().zwqqyj[languageIndex]}}</p>
			</div>
			<div class="points_box">
				<p>{{langtrans().jyddjx[languageIndex]}}</p>
			</div>
		</header>
		<main class="main">
			<h2 class="title">{{langtrans().rfwfjf[languageIndex]}}</h2>
			<ul class="list">
				<li>
					<img src="./images/overseas_icon_01.png" alt="">
					<h4>{{langtrans().fxyj[languageIndex]}}</h4>
					<p>{{langtrans().dtxsxm[languageIndex]}}</p>
				</li>
				<li>
					<img src="./images/overseas_icon_02.png" alt="">
					<h4>{{langtrans().afgl[languageIndex]}}</h4>
					<p>{{langtrans().nbsdab[languageIndex]}}</p>
				</li>
				<li>
					<img src="./images/overseas_icon_03.png" alt="">
					<h4>{{langtrans().yyjgl[languageIndex]}}</h4>
					<p>{{langtrans().bzyyjs[languageIndex]}}</p>
				</li>
			</ul>
			<p class="btn_node">
				<button @click="setjlhz">{{langtrans().jlhgzz[languageIndex]}}</button>
			</p>
		</main>
		<vFooter @performHeader=performHeader></vFooter>
		<jlhzBox ref=jlhzBox></jlhzBox>
	</div>
</template>

<script>
	import langtrans from "@/assets/languagejs/overseas.vue.trans.js";
	import {
		Message
	} from "element-ui";
	import constants from "@/util/constants.js";
	import navHeader from '@/components/header/indexHeader'
	import vFooter from '@/components/footer/indexFooter'
	import { postCooperation } from '@/views/axios/api.js';
	import jlhzBox from './jlhz'
	export default {
		data() {
			return {
				flag: true,
				usertype: "",
				user: "",
				pwd: "",
				form: {},
				successdialog: false,
				dialogFormVisible: false
			};
		},
		components: {
			navHeader,
			vFooter,
			jlhzBox
		},
		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		methods: {
			langtrans() {
				return langtrans
			},
			setjlhz() {
				this.$refs.jlhzBox.setpopShow('true', 4)
			},
			performHeader(str) {
				this.$refs.navHeader.login(str)
			},
		}
	};
</script>

<style scoped>
	@import url(./css/programme.css);

	.points_box p {
		text-align: center;
		line-height: 1.45vw;
		padding: 4vw 21.3vw;
		font-size: 1.04vw;
	}


	.main .list li p {
		padding: 0 2vw;
	}
</style>



// WEBPACK FOOTER //
// src/components/programme/overseas.vue